// Keep these rules aligned with backend/cnam.py; tested against shared fixtures.
export const canonicalCNAM=value=>String(value??'').normalize('NFC').trim().toLowerCase();
export function matchingPrefixes(name,prefixes=[]){
 if(!Array.isArray(prefixes))return [];
 const value=canonicalCNAM(name),alnum=c=>/[\p{L}\p{N}]/u.test(c||'');
 return prefixes.filter(raw=>{
  if(typeof raw!=='string')return false;
  const prefix=canonicalCNAM(raw);if(!prefix||!value.startsWith(prefix))return false;
  return !alnum([...prefix].at(-1))||value.length===prefix.length||!alnum([...value.slice(prefix.length)][0]);
 }).map(raw=>raw.trim());
}
